angular.module('surfsightApp.controllers').controller('OrganizationsCtrl', [
  '$scope',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  '$interval',
  '$timeout',
  '$mdSidenav',
  '$translate',
  '$log',
  function (
    $scope,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdToast,
    $interval,
    $timeout,
    $mdSidenav,
    $translate,
    $log
  ) {
    var $translate = $filter('translate')
    $scope.partnerData = $localStorage.partnerData
    $scope.newOrganization = {}
    $scope.newOrganization.reseller_id = $scope.partnerData.id
    $scope.addOrganization = function () {
      var name = $scope.newOrganization.name
      if (name) {
        var request_json = {
          method: 'POST',
          url: USER_BASEURL + '/organizations',
          data: $scope.newOrganization
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code == 0) {
              $mdDialog.hide(response)
            } else {
              $scope.showMessageToast(response.data.status.error)
            }
          },
          function (response) {
            if (response && response.data) {
              if (response.data.statusCode == 401) {
                $state.go('home.login')
              }
            } else {
              $scope.showMessageToast('Error occurred.')
            }
          }
        )
      }
    }
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .action($translate('ok'))
        .position('top right')
        .actionKey('F1')
        .hideDelay(5000)
      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
          }
        })
        .catch(() => {})
    }
  }
])
